export default ($t) => ({
  title: "TeamsConfig",
  type: "object",
  expanded: true,
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
    skip_without_goal_and_donations: {
      title: $t(
        "edit_campaign.schema_teams_config_skip_without_goal_and_donations",
        "Skip teams without goal and donations"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_teams_config_skip_without_goal_and_donations_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    skip_without_donations: {
      title: $t(
        "edit_campaign.schema_teams_config_skip_without_donations",
        "Skip teams without donations"
      ),
      type: "boolean",
      default: false,
      description: $t("edit_campaign.schema_teams_config_skip_without_donations_description", {
        returnEmptyOnMissing: true,
      }),
    },
    use_team_description_on_share_preview: {
      title: $t(
        "edit_campaign.schema_teams_config_use_team_description_on_share_preview",
        "Use team description on share preview"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_teams_config_use_team_description_on_share_preview_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    show_children_stats: {
      title: $t(
        "edit_campaign.schema_teams_config_show_children_stats",
        "Show children statistics"
      ),
      type: "boolean",
      default: false,
      description: $t("edit_campaign.schema_teams_config_show_children_stats_description", {
        returnEmptyOnMissing: true,
      }),
    },
    icon_by_raised_amount_threshold: {
      title: $t(
        "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold",
        "Icons by raised amount thresholds"
      ),
      type: "list",
      default: [],
      expanded: true,
      description: $t(
        "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
      items: {
        type: "object",
        properties: {
          from: {
            title: $t(
              "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold_items_from",
              "From amount (inclusive)"
            ),
            type: "number",
            default: 0,
            description: $t(
              "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold_items_from_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          to: {
            title: $t(
              "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold_items_to",
              "To amount"
            ),
            type: "number",
            default: 0,
            description: $t(
              "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold_items_to_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          icon_src: {
            title: $t(
              "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold_items_icon_src",
              "Icon URL"
            ),
            type: "image",
            default: "",
            description: $t(
              "edit_campaign.schema_teams_config_icon_by_raised_amount_threshold_items_icon_src_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
        },
      },
    },
  },
});
